"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryContractParamsResponse = exports.QueryContractParamsRequest = exports.QueryContractAllResponse = exports.QueryContractAllRequest = exports.QueryContractAddressResponse = exports.QueryContractAddressRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryOracleVotesWindowResponse = exports.QueryOracleVotesWindowRequest = exports.QueryAllOracleVotesWindowResponse = exports.QueryAllOracleVotesWindowRequest = exports.QuerySlashCounterResponse = exports.QuerySlashCounterRequest = exports.QueryAllSlashCounterResponse = exports.QueryAllSlashCounterRequest = exports.QueryVoterPowerResponse = exports.QueryVoterPowerRequest = exports.QueryVotesResponse = exports.QueryVotesRequest = exports.QueryResultsLatestResponse = exports.QueryResultsLatestRequest = exports.QueryResultsResponse = exports.QueryResultsRequest = exports.QueryAllOracleResponse = exports.QueryAllOracleRequest = exports.QueryOracleResponse = exports.QueryOracleRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const oracle_1 = require("./oracle");
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const slashing_1 = require("./slashing");
const params_1 = require("./params");
exports.protobufPackage = "Switcheo.carbon.oracle";
const baseQueryOracleRequest = { id: "" };
exports.QueryOracleRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryOracleRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryOracleRequest);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryOracleRequest);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryOracleResponse = {};
exports.QueryOracleResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.oracle !== undefined) {
            oracle_1.Oracle.encode(message.oracle, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryOracleResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracle = oracle_1.Oracle.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryOracleResponse);
        message.oracle =
            object.oracle !== undefined && object.oracle !== null
                ? oracle_1.Oracle.fromJSON(object.oracle)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.oracle !== undefined &&
            (obj.oracle = message.oracle ? oracle_1.Oracle.toJSON(message.oracle) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryOracleResponse);
        message.oracle =
            object.oracle !== undefined && object.oracle !== null
                ? oracle_1.Oracle.fromPartial(object.oracle)
                : undefined;
        return message;
    },
};
const baseQueryAllOracleRequest = {};
exports.QueryAllOracleRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllOracleRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllOracleRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllOracleRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllOracleResponse = {};
exports.QueryAllOracleResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.oracles) {
            oracle_1.Oracle.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllOracleResponse);
        message.oracles = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracles.push(oracle_1.Oracle.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllOracleResponse);
        message.oracles = ((_a = object.oracles) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Oracle.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.oracles) {
            obj.oracles = message.oracles.map((e) => e ? oracle_1.Oracle.toJSON(e) : undefined);
        }
        else {
            obj.oracles = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllOracleResponse);
        message.oracles = ((_a = object.oracles) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Oracle.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryResultsRequest = { oracleId: "" };
exports.QueryResultsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.oracleId !== "") {
            writer.uint32(10).string(message.oracleId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryResultsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleId = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryResultsRequest);
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryResultsRequest);
        message.oracleId = (_a = object.oracleId) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryResultsResponse = {};
exports.QueryResultsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.results) {
            oracle_1.Result.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryResultsResponse);
        message.results = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.results.push(oracle_1.Result.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryResultsResponse);
        message.results = ((_a = object.results) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Result.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.results) {
            obj.results = message.results.map((e) => e ? oracle_1.Result.toJSON(e) : undefined);
        }
        else {
            obj.results = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryResultsResponse);
        message.results = ((_a = object.results) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Result.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryResultsLatestRequest = {};
exports.QueryResultsLatestRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryResultsLatestRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryResultsLatestRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryResultsLatestRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryResultsLatestResponse = {};
exports.QueryResultsLatestResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.latestResults) {
            oracle_1.Result.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryResultsLatestResponse);
        message.latestResults = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.latestResults.push(oracle_1.Result.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryResultsLatestResponse);
        message.latestResults = ((_a = object.latestResults) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Result.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.latestResults) {
            obj.latestResults = message.latestResults.map((e) => e ? oracle_1.Result.toJSON(e) : undefined);
        }
        else {
            obj.latestResults = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryResultsLatestResponse);
        message.latestResults = ((_a = object.latestResults) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Result.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryVotesRequest = {
    oracleId: "",
    timestamp: long_1.default.ZERO,
    voter: "",
};
exports.QueryVotesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.oracleId !== "") {
            writer.uint32(10).string(message.oracleId);
        }
        if (!message.timestamp.isZero()) {
            writer.uint32(16).int64(message.timestamp);
        }
        if (message.voter !== "") {
            writer.uint32(26).string(message.voter);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryVotesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleId = reader.string();
                    break;
                case 2:
                    message.timestamp = reader.int64();
                    break;
                case 3:
                    message.voter = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryVotesRequest);
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromString(object.timestamp)
                : long_1.default.ZERO;
        message.voter =
            object.voter !== undefined && object.voter !== null
                ? String(object.voter)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        message.timestamp !== undefined &&
            (obj.timestamp = (message.timestamp || long_1.default.ZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryVotesRequest);
        message.oracleId = (_a = object.oracleId) !== null && _a !== void 0 ? _a : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromValue(object.timestamp)
                : long_1.default.ZERO;
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryVotesResponse = {};
exports.QueryVotesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.votes) {
            oracle_1.Vote.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryVotesResponse);
        message.votes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.votes.push(oracle_1.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryVotesResponse);
        message.votes = ((_a = object.votes) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Vote.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.votes) {
            obj.votes = message.votes.map((e) => (e ? oracle_1.Vote.toJSON(e) : undefined));
        }
        else {
            obj.votes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryVotesResponse);
        message.votes = ((_a = object.votes) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Vote.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryVoterPowerRequest = { address: "" };
exports.QueryVoterPowerRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryVoterPowerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryVoterPowerRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryVoterPowerRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryVoterPowerResponse = { power: "" };
exports.QueryVoterPowerResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.power !== "") {
            writer.uint32(10).string(message.power);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryVoterPowerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.power = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryVoterPowerResponse);
        message.power =
            object.power !== undefined && object.power !== null
                ? String(object.power)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.power !== undefined && (obj.power = message.power);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryVoterPowerResponse);
        message.power = (_a = object.power) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryAllSlashCounterRequest = {};
exports.QueryAllSlashCounterRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllSlashCounterRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllSlashCounterRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllSlashCounterRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllSlashCounterResponse = {};
exports.QueryAllSlashCounterResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.slashCounters) {
            slashing_1.SlashCounter.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllSlashCounterResponse);
        message.slashCounters = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.slashCounters.push(slashing_1.SlashCounter.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllSlashCounterResponse);
        message.slashCounters = ((_a = object.slashCounters) !== null && _a !== void 0 ? _a : []).map((e) => slashing_1.SlashCounter.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.slashCounters) {
            obj.slashCounters = message.slashCounters.map((e) => e ? slashing_1.SlashCounter.toJSON(e) : undefined);
        }
        else {
            obj.slashCounters = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllSlashCounterResponse);
        message.slashCounters = ((_a = object.slashCounters) !== null && _a !== void 0 ? _a : []).map((e) => slashing_1.SlashCounter.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQuerySlashCounterRequest = { valoperAddress: "" };
exports.QuerySlashCounterRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.valoperAddress !== "") {
            writer.uint32(10).string(message.valoperAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQuerySlashCounterRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valoperAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQuerySlashCounterRequest);
        message.valoperAddress =
            object.valoperAddress !== undefined && object.valoperAddress !== null
                ? String(object.valoperAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.valoperAddress !== undefined &&
            (obj.valoperAddress = message.valoperAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQuerySlashCounterRequest);
        message.valoperAddress = (_a = object.valoperAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQuerySlashCounterResponse = {};
exports.QuerySlashCounterResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.slashCounter !== undefined) {
            slashing_1.SlashCounter.encode(message.slashCounter, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQuerySlashCounterResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.slashCounter = slashing_1.SlashCounter.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQuerySlashCounterResponse);
        message.slashCounter =
            object.slashCounter !== undefined && object.slashCounter !== null
                ? slashing_1.SlashCounter.fromJSON(object.slashCounter)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.slashCounter !== undefined &&
            (obj.slashCounter = message.slashCounter
                ? slashing_1.SlashCounter.toJSON(message.slashCounter)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQuerySlashCounterResponse);
        message.slashCounter =
            object.slashCounter !== undefined && object.slashCounter !== null
                ? slashing_1.SlashCounter.fromPartial(object.slashCounter)
                : undefined;
        return message;
    },
};
const baseQueryAllOracleVotesWindowRequest = {};
exports.QueryAllOracleVotesWindowRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllOracleVotesWindowRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllOracleVotesWindowRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllOracleVotesWindowRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllOracleVotesWindowResponse = {};
exports.QueryAllOracleVotesWindowResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.oracleVotesWindows) {
            slashing_1.OracleVotesWindow.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllOracleVotesWindowResponse);
        message.oracleVotesWindows = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleVotesWindows.push(slashing_1.OracleVotesWindow.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllOracleVotesWindowResponse);
        message.oracleVotesWindows = ((_a = object.oracleVotesWindows) !== null && _a !== void 0 ? _a : []).map((e) => slashing_1.OracleVotesWindow.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.oracleVotesWindows) {
            obj.oracleVotesWindows = message.oracleVotesWindows.map((e) => e ? slashing_1.OracleVotesWindow.toJSON(e) : undefined);
        }
        else {
            obj.oracleVotesWindows = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllOracleVotesWindowResponse);
        message.oracleVotesWindows = ((_a = object.oracleVotesWindows) !== null && _a !== void 0 ? _a : []).map((e) => slashing_1.OracleVotesWindow.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryOracleVotesWindowRequest = { valoperAddress: "" };
exports.QueryOracleVotesWindowRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.valoperAddress !== "") {
            writer.uint32(10).string(message.valoperAddress);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryOracleVotesWindowRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valoperAddress = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryOracleVotesWindowRequest);
        message.valoperAddress =
            object.valoperAddress !== undefined && object.valoperAddress !== null
                ? String(object.valoperAddress)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.valoperAddress !== undefined &&
            (obj.valoperAddress = message.valoperAddress);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryOracleVotesWindowRequest);
        message.valoperAddress = (_a = object.valoperAddress) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryOracleVotesWindowResponse = {};
exports.QueryOracleVotesWindowResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.oracleVotesWindows) {
            slashing_1.OracleVotesWindow.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryOracleVotesWindowResponse);
        message.oracleVotesWindows = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleVotesWindows.push(slashing_1.OracleVotesWindow.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryOracleVotesWindowResponse);
        message.oracleVotesWindows = ((_a = object.oracleVotesWindows) !== null && _a !== void 0 ? _a : []).map((e) => slashing_1.OracleVotesWindow.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.oracleVotesWindows) {
            obj.oracleVotesWindows = message.oracleVotesWindows.map((e) => e ? slashing_1.OracleVotesWindow.toJSON(e) : undefined);
        }
        else {
            obj.oracleVotesWindows = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryOracleVotesWindowResponse);
        message.oracleVotesWindows = ((_a = object.oracleVotesWindows) !== null && _a !== void 0 ? _a : []).map((e) => slashing_1.OracleVotesWindow.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseQueryContractAddressRequest = { id: "" };
exports.QueryContractAddressRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryContractAddressRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryContractAddressRequest);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryContractAddressRequest);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryContractAddressResponse = { address: "" };
exports.QueryContractAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryContractAddressResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryContractAddressResponse);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryContractAddressResponse);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryContractAllRequest = {};
exports.QueryContractAllRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryContractAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryContractAllRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryContractAllRequest);
        return message;
    },
};
const baseQueryContractAllResponse = {};
exports.QueryContractAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.contracts) {
            oracle_1.Contract.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryContractAllResponse);
        message.contracts = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.contracts.push(oracle_1.Contract.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryContractAllResponse);
        message.contracts = ((_a = object.contracts) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Contract.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.contracts) {
            obj.contracts = message.contracts.map((e) => e ? oracle_1.Contract.toJSON(e) : undefined);
        }
        else {
            obj.contracts = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryContractAllResponse);
        message.contracts = ((_a = object.contracts) !== null && _a !== void 0 ? _a : []).map((e) => oracle_1.Contract.fromPartial(e));
        return message;
    },
};
const baseQueryContractParamsRequest = { id: "" };
exports.QueryContractParamsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryContractParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryContractParamsRequest);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryContractParamsRequest);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryContractParamsResponse = {
    id: "",
    creator: "",
    decimals: long_1.default.UZERO,
    timestamp: "",
    data: "",
};
exports.QueryContractParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.creator !== "") {
            writer.uint32(18).string(message.creator);
        }
        if (!message.decimals.isZero()) {
            writer.uint32(24).uint64(message.decimals);
        }
        if (message.timestamp !== "") {
            writer.uint32(34).string(message.timestamp);
        }
        if (message.data !== "") {
            writer.uint32(42).string(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryContractParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.decimals = reader.uint64();
                    break;
                case 4:
                    message.timestamp = reader.string();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryContractParamsResponse);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromString(object.decimals)
                : long_1.default.UZERO;
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? String(object.timestamp)
                : "";
        message.data =
            object.data !== undefined && object.data !== null
                ? String(object.data)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.creator !== undefined && (obj.creator = message.creator);
        message.decimals !== undefined &&
            (obj.decimals = (message.decimals || long_1.default.UZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        message.data !== undefined && (obj.data = message.data);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseQueryContractParamsResponse);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.creator = (_b = object.creator) !== null && _b !== void 0 ? _b : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromValue(object.decimals)
                : long_1.default.UZERO;
        message.timestamp = (_c = object.timestamp) !== null && _c !== void 0 ? _c : "";
        message.data = (_d = object.data) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Oracle = this.Oracle.bind(this);
        this.OracleAll = this.OracleAll.bind(this);
        this.Results = this.Results.bind(this);
        this.ResultsLatest = this.ResultsLatest.bind(this);
        this.Votes = this.Votes.bind(this);
        this.VoterPower = this.VoterPower.bind(this);
        this.SlashCounterAll = this.SlashCounterAll.bind(this);
        this.SlashCounter = this.SlashCounter.bind(this);
        this.OracleVotesWindowAll = this.OracleVotesWindowAll.bind(this);
        this.OracleVotesWindow = this.OracleVotesWindow.bind(this);
        this.OracleContractAddress = this.OracleContractAddress.bind(this);
        this.OracleContractAll = this.OracleContractAll.bind(this);
        this.OracleContractParams = this.OracleContractParams.bind(this);
        this.Params = this.Params.bind(this);
    }
    Oracle(request) {
        const data = exports.QueryOracleRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "Oracle", data);
        return promise.then((data) => exports.QueryOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
    OracleAll(request) {
        const data = exports.QueryAllOracleRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "OracleAll", data);
        return promise.then((data) => exports.QueryAllOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
    Results(request) {
        const data = exports.QueryResultsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "Results", data);
        return promise.then((data) => exports.QueryResultsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ResultsLatest(request) {
        const data = exports.QueryResultsLatestRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "ResultsLatest", data);
        return promise.then((data) => exports.QueryResultsLatestResponse.decode(new minimal_1.default.Reader(data)));
    }
    Votes(request) {
        const data = exports.QueryVotesRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "Votes", data);
        return promise.then((data) => exports.QueryVotesResponse.decode(new minimal_1.default.Reader(data)));
    }
    VoterPower(request) {
        const data = exports.QueryVoterPowerRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "VoterPower", data);
        return promise.then((data) => exports.QueryVoterPowerResponse.decode(new minimal_1.default.Reader(data)));
    }
    SlashCounterAll(request) {
        const data = exports.QueryAllSlashCounterRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "SlashCounterAll", data);
        return promise.then((data) => exports.QueryAllSlashCounterResponse.decode(new minimal_1.default.Reader(data)));
    }
    SlashCounter(request) {
        const data = exports.QuerySlashCounterRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "SlashCounter", data);
        return promise.then((data) => exports.QuerySlashCounterResponse.decode(new minimal_1.default.Reader(data)));
    }
    OracleVotesWindowAll(request) {
        const data = exports.QueryAllOracleVotesWindowRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "OracleVotesWindowAll", data);
        return promise.then((data) => exports.QueryAllOracleVotesWindowResponse.decode(new minimal_1.default.Reader(data)));
    }
    OracleVotesWindow(request) {
        const data = exports.QueryOracleVotesWindowRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "OracleVotesWindow", data);
        return promise.then((data) => exports.QueryOracleVotesWindowResponse.decode(new minimal_1.default.Reader(data)));
    }
    OracleContractAddress(request) {
        const data = exports.QueryContractAddressRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "OracleContractAddress", data);
        return promise.then((data) => exports.QueryContractAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    OracleContractAll(request) {
        const data = exports.QueryContractAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "OracleContractAll", data);
        return promise.then((data) => exports.QueryContractAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    OracleContractParams(request) {
        const data = exports.QueryContractParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "OracleContractParams", data);
        return promise.then((data) => exports.QueryContractParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
